var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{attrs:{"data-testid":"quote"}},[_vm._v(_vm._s(_vm.quote.quote))]),_c('span',{staticClass:"ml-10 italic",attrs:{"data-testid":"source"}},[_vm._v("- "+_vm._s(_vm.quote.source))])])}
var staticRenderFns = []

export { render, staticRenderFns }